import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';

import i18n from './i18n';

let storeReference = null;
export const setStoreReference = (store) => {
  storeReference = store;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API + '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch (error) {
    return true;
  }
};

api.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem('token');
    if (token) {
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');

        if (storeReference) {
          const { logoutRequested } = require('./redux/slices/authSlice');
          storeReference.dispatch(logoutRequested());
          toast.error(i18n.t('auth.sessionExpired'));
        }
      } else {
        request.headers['Authorization'] = 'Bearer ' + token;
      }
    }
    return request;
  },
  function (error) {
    toast.error(error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // console.log('Response:', response);
    if (response.data.data && response.data.data.accessToken) {
      api.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.data.accessToken;
      localStorage.setItem('token', response.data.data.accessToken);
    }
    return response;
  },
  function (error) {
    error = error.response.data;
    // toast.error(error);
    let errorMsg = error.message || '';
    if (error.errors && error.errors.message) errorMsg = errorMsg + ': ' + error.errors.message;
    // toast.error(errorMsg);
    return Promise.reject(error);
  }
);

export default api;
